<template>
<v-timeline dense clipped>
  <v-timeline-item v-if="!sender" color="grey" icon-color="grey lighten-2">
    <Avatar slot="icon" :user="{photoURL: details.photoURL, displayName: details.displayName}" :title="details.displayName" large />
    <v-layout text-xs-left justify-space-between>
      <v-flex xs12>{{details.message}}</v-flex>
    </v-layout>
  </v-timeline-item>
  <v-timeline-item v-else color="grey" icon-color="grey lighten-2">
    <Avatar slot="icon" :user="{photoURL: details.photoURL, displayName: details.displayName}" :title="details.displayName" large />
    <v-layout text-xs-left justify-space-between>
      <v-flex xs12>{{details.message}}</v-flex>
    </v-layout>
  </v-timeline-item>
</v-timeline>
<!--<div v-if="!sender" class="message">
  <div class="message-inline">
    <div class="message-profile">
      <Avatar :user="{photoURL: details.photoURL, displayName: details.displayName}" :title="details.displayName" />
    </div>
    <p class="message-content">{{details.message}}</p>
  </div>
</div>
<div v-else class="message sent">
  <div class="message-inline">
    <p class="message-content">{{details.message}}</p>
  </div>
</div> -->
</template>

<script>
import Avatar from "@/components/User/Avatar";
import {
  db,
  FirebaseConsts
} from "@/firebaseConfig";
import {
  getGroupData
} from "@/scripts/groupFuncs";
export default {
  name: "Message",
  components: {
    Avatar
  },
  props: {
    sender: {
      type: Boolean,
      default: false
    },
    details: Object,
    color: {
      type: String,
      default: "#f2f2f2"
    },
  },
  computed: {
    timeline() {
      return this.events.slice().reverse()
    }
  }
};
</script>


<style lang="scss" scoped>
.message {
    margin-bottom: 5px;
    max-width: 90%;

    .message-sender {
        text-align: left;
        color: black;
        margin: 0 45px;
        font-size: 10px;
        font-weight: bold;
    }

    .message-inline {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        padding: 0 4px 8px;
        margin: 0 4px 15px;
        //background: #f9f9f9;

        .message-profile {
            align-self: flex-start;
            display: inline-block;
            margin-left: 2px;
            margin-bottom: 2px;

            .avatar.avatar-lg {
                width: 30px;
                height: 30px;
                font-size: 15px;
            }
        }

        .message-content {
            text-align: left;
            margin: 0 4px;
            display: inline-block;
            padding: 3px 6px;
            border-radius: 16px;
            // margin-left: 10px;
            word-break: keep-all;
        }
    }
}

// Show your sent messages on the right
.message.sent {
    width: 100%;
    .message-inline {
        flex-direction: row-reverse;
        .message-content {
            margin-left: 35px;
            padding: 3px 15px 3px 6px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Chat/Message.vue